import {
    getConfiCostLoading,
    getConfiCostReject,
    getConfiCostRequest,
    getConfiCostSuccess
} from "../../actions/costGlobal/getAll";

export const getConfiCost = (formData) => async (dispatch, getState) => {
    dispatch(getConfiCostLoading());
    try {
        const { data } = await getConfiCostRequest(formData, getState);
        dispatch(getConfiCostSuccess(data))
    } catch (error) {
        dispatch(getConfiCostReject(error))
    }
    return Promise.resolve();
};